import { useCallback } from 'react'
import { Auth } from 'aws-amplify'

export const useAdminLogin = () => {
  return useCallback(async (login, password) => {
    return await Auth.signIn(login, password)
  }, [])
}
